import React, { ReactNode } from 'react'

import { FooterMeta, HeaderMeta } from '../data'
import { FooterCustom, Header } from './ui'

export const Wrapper = (props: { children?: ReactNode, className?: string }) => {
    const { children = false, className = '' } = props

    return (
        <div className={`flex flex-col w-full h-[100vh]`}>
            <Header meta={HeaderMeta} className={`sticky top-0 z-50`} />

            <main className={`flex flex-grow bg-gray-50 dark:bg-gray-900 ${className}`}>
                {children}
            </main>

            <FooterCustom meta={FooterMeta} />
        </div>
    )
}
